/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.10",
    versionName: "0.2.0-nightly.2025.10.10",
    versionChannel: "nightly",
    buildDate: "2025-10-10T00:08:10.288Z",
    commitHash: "9d06a0b760d6b4df3b082a058f481cfe2621cde5",
};
